export default __webpack_public_path__ + "static/media/k8.244bbbd4.png";